package com.nonopn.skywatcher.common.app.pages.map.view.map

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionSurroundingContext
import com.nonopn.skywatcher.common.app.api.impl.ThunderDetectionSurroundingUser
import com.nonopn.skywatcher.common.app.api.impl.WarnStateValidationState
import com.nonopn.skywatcher.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.pages.map.model.FakeMainScreenModel
import com.nonopn.skywatcher.common.app.pages.map.model.MainScreenModel
import compose.icons.WeatherIcons
import compose.icons.weathericons.Lightning
import de.drick.compose.hotpreview.HotPreview

@Composable
fun CounterLightning(
    modifier: Modifier,
    model: MainScreenModel
) {
    val states by model.states.collectAsState()
    CounterDefault(
        modifier,
        model,
        rememberVectorPainter(WeatherIcons.Lightning),
        "${states.lightningActivity.size}"
    ) {
        model.openLightningDrawer()
    }
}

@Composable
@HotPreview(widthDp = 150, heightDp = 50, darkMode = true)
@HotPreview(widthDp = 150, heightDp = 50, darkMode = false)
private fun CounterUsersPreview() {
    HotPreviewApp(Modifier.fillMaxSize(), isDarkTheme = isSystemInDarkTheme()) {
        CounterUsers(
            Modifier.fillMaxSize(),
            FakeMainScreenModel(
                false,
                null,
                ThunderDetectionSurroundingContext(
                    (0..94).map {
                        ThunderDetectionSurroundingUser(
                            id = "$it",
                            latitude = 0.0,
                            longitude = 0.0,
                            alertState = WarnStateValidationState.AllClear
                        )
                    }
                )
            )
        )
    }
}
